import React from 'react';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <p className="copyright">&copy; Jerry Liu {new Date().getFullYear()}</p>
    </footer>
  );
};

export default Footer;
